import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Glue the last two words of a title with a non-breaking space so a clamped
 * card title never strands a single word on its final line. Needed because
 * Chrome ignores `text-wrap: balance/pretty` on line-clamped boxes (the CSS
 * rules in styles.css still cover other browsers and non-clamped headings).
 * Strings with fewer than 3 words are returned untouched so a short title can
 * never become one unbreakable run. Only the final regular space is collapsed.
 */
export function noWidow(text: string): string {
  if (text.split(/\s+/).filter(Boolean).length < 3) return text;
  const i = text.lastIndexOf(" ");
  if (i <= 0) return text;
  return `${text.slice(0, i)} ${text.slice(i + 1)}`;
}
